import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter019() {
  return <KbChapterPage slug="chapter-019" />;
}

(Chapter019 as unknown as { path: string }).path = "/theory-album/019";
